var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
            `
                absolute
                top-0
                right-6
                bottom-0
                z-50
                m-auto
                flex
                focus:outline-none
                items-center
                justify-center
                lg:hidden
                menu-button
                outline-none
            `,
            {
                open: _vm.isOpen,
            },
        ],attrs:{"aria-label":"Toggle mobile menu"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-button-inner"},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])
}]

export { render, staticRenderFns }